export default __webpack_public_path__ + "static/media/empty-video.6781d455.png";